import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import Swal from "sweetalert2";

export class ModHeader extends ModuleComponent{

    getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    ready(){
        super.ready();
        this.findMember("opener").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.findMember("mobile-menu").toggleClass("is-opened");
                $("body").toggleClass("web-no-scroll");
                this.findMember("main-menu").toggleClass("is-opened");
                $(".js-mod-private-zone-header__main-menu").toggleClass("is-opened");
            }
        );

        this.findMember("main-menu-a").click(
            function(ev){
                this.findMember(this.scope+"opener:visible").click();
            }
        );

        this.findMember("search-btn-view").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.findMember("search-btn-view").toggleClass("is-visible");
                this.findMember("search-content").toggleClass("is-visible");
            }
        );

        /*MENU USUARIO LOGUEADO*/
        this.findMember("user").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.findMember("user-menu").toggleClass("is-opened");
                $("body").toggleClass("u-no-scroll");
            }
        );
        this.findMember("user-private-close").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.findMember("user-menu").toggleClass("is-opened");
                $("body").toggleClass("u-no-scroll");
            }
        );



        this.findMember("search-btn-view").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.findMember("search-btn-view").toggleClass("is-visible");
                this.findMember("search-content").toggleClass("is-visible");
            }
        );

        this.findMember("user-logout").click(
            (ev)=>{
                ev.preventDefault();
                Swal.fire({
                    title: "¿Estás seguro de que deseas cerrar sesión?",
                    showLoaderOnConfirm: true,
                    confirmButtonColor: "#ef7d00",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                    showCancelButton: true,
                    preConfirm: (value) => {
                        GvfService.endpoint(
                            "/web/login/logout",
                            {},
                        ).then(
                            (resp)=>{
                                if(resp.result){
                                    window.location = resp.url;
                                }
                            }
                        );
                    }
                });
            }
        );

    }
}